export function parseCSSNumberValue(cssNumberValue) {

  const result = {
    valid: false,
    number: 0,
    unit: 'px',
    validValue: 'auto'
  };

  if (cssNumberValue === 'auto') {
    result.valid = true;
    result.validValue = 'auto';
    return result;
  }

  const pxIndex = cssNumberValue.indexOf('px');
  const percentIndex = cssNumberValue.indexOf('%');

  if (pxIndex !== -1) {
    result.unit = 'px';
  } else if (percentIndex !== -1) {
    result.unit = '%';
  }

  if (pxIndex !== -1 && percentIndex !== -1) {

    if (pxIndex > percentIndex) {
      result.unit = '%';
    } else {
      result.unit = 'px';
    }

  }

  result.number = +cssNumberValue.replace(/px/g, '').replace(/%/g, '');

  if (isNaN(result.number) === false) {
    result.valid = true;

    if (result.number === 0) {
      result.validValue = 0;
    } else {
      result.validValue = result.number + result.unit;
    }

  }

  return result;

}